import React, { useState } from 'react';
import { supabase } from '../../supabase';
import { fmtDate } from '../../utils/formatting';
import VendorProfileModal from '../modals/VendorProfileModal';
import InviteDatePickerModal from '../modals/InviteDatePickerModal';

function VendorCard({ v, contacted, setContacted, showDist, outOfRange, openMessage, sendBookingRequest, bookingRequests, setBookingRequests, hostEvent, setTab, vendorCalendars, setVendorCalendars, authUser, setShowAuthModal, matchPct, setInquiryModal, setEventMessageModal, userEvents }) {
  const [showProfile, setShowProfile] = useState(false);
  const [inviteDatePicker, setInviteDatePicker] = useState(null); // {vendor, series}
  const req = bookingRequests && bookingRequests.find(r => r.vendorId === v.id && (!hostEvent?.eventId || r.eventId === hostEvent.eventId || r.eventName === hostEvent?.eventName));
  const hasPhotos = v.photoUrls && v.photoUrls.length > 0;
  const isGuest = !authUser;

  // Unauthenticated: show limited card
  if (isGuest) {
    return (
      <div className="vendor-card">
        <div className="vendor-card-top" style={{background:'linear-gradient(135deg,#1a1410,#2d2118)'}}>
          {v.emoji}
          <div className="match-score">{v.matchScore}% match</div>
        </div>
        <div className="vendor-card-body">
          <div className="vendor-name" style={{color:'#a89a8a',fontStyle:'italic'}}>🔒 Vendor Name Hidden</div>
          <div className="vendor-category">
            {v.isServiceProvider && v.serviceCategories?.length > 0
              ? v.serviceCategories.join(', ')
              : (v.allCategories || [v.category]).length > 1
                ? `${v.category} +${(v.allCategories || [v.category]).length - 1} more`
                : v.category}
          </div>
          {v.isServiceProvider && <div style={{fontSize:11,color:'#c8a850',marginBottom:4}}>Service Provider</div>}
          <div className="vendor-tags">
            {v.insurance && <span className="vendor-tag" style={{ background:'#d4f4e0', color:'#1a6b3a', borderColor:'#b8e8c8' }}>✓ Insured</span>}
          </div>
          <p style={{ fontSize:13, color:'#7a6a5a', lineHeight:1.5, marginBottom:10 }}>{v.description}</p>
          {v.price && <div style={{fontSize:13,color:'#1a1410',fontWeight:600,marginBottom:6}}>💰 {v.price}</div>}
          <div className="vendor-meta">
            <div className="vendor-location">📍 {v.homeZip} · travels {v.radius}mi</div>
          </div>
          {showDist && (
            outOfRange
              ? <div className="vendor-no-match">✗ {v.dist!==null?`${v.dist.toFixed(1)} mi away`:'distance unknown'} — outside travel range</div>
              : <div className="vendor-distance">✓ {v.dist!==null?`${v.dist.toFixed(1)} mi from your event`:'within range (zip unverified)'}</div>
          )}
          <div style={{background:'#fdf9f5',border:'1px solid #e8ddd0',borderRadius:8,padding:'12px 14px',marginTop:12,textAlign:'center'}}>
            <div style={{fontSize:12,color:'#7a5a10',marginBottom:8}}>🔒 Create a free host account to see full vendor profiles, photos, and social links</div>
            <button onClick={()=>{if(setShowAuthModal)setShowAuthModal(true);}}
              style={{background:'#c8a84b',color:'#1a1410',border:'none',borderRadius:6,padding:'8px 20px',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
              Sign Up Free
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="vendor-card" style={{cursor:'pointer'}} onClick={()=>setShowProfile(true)}>
      {hasPhotos ? (
        <div style={{position:'relative',height:120,overflow:'hidden',borderRadius:'12px 12px 0 0'}}>
          <img src={v.photoUrls[0]} alt={v.name} style={{width:'100%',height:'100%',objectFit:'cover'}} />
          <div style={{position:'absolute',inset:0,background:'linear-gradient(to bottom,transparent 40%,rgba(26,20,16,0.5) 100%)'}} />
          <div style={{position:'absolute',top:10,left:10,fontSize:24}}>{v.emoji}</div>
          <div className="match-score" style={{position:'absolute',top:10,right:10}}>{matchPct !== null && matchPct !== undefined ? `${matchPct}%` : `${v.matchScore}%`} match</div>
        </div>
      ) : (
        <div className="vendor-card-top">
          {v.emoji}
          <div className="match-score">{matchPct !== null && matchPct !== undefined ? `${matchPct}%` : `${v.matchScore}%`} match</div>
        </div>
      )}
      <div className="vendor-card-body">
        <div className="vendor-name">{v.name}</div>
        <div className="vendor-category">
          {v.isServiceProvider && v.serviceCategories?.length > 0
            ? v.serviceCategories.join(', ')
            : (v.allCategories || [v.category]).length > 1
              ? `${v.category} +${(v.allCategories || [v.category]).length - 1} more`
              : v.category}
        </div>
        {v.isServiceProvider && <div style={{fontSize:11,color:'#c8a850',marginBottom:4}}>Service Provider{v.serviceType ? ` · ${v.serviceType}` : ''}</div>}
        <div className="vendor-tags">
          {v.insurance && <span className="vendor-tag" style={{ background:'#d4f4e0', color:'#1a6b3a', borderColor:'#b8e8c8' }}>✓ Insured</span>}
        </div>
        <p style={{ fontSize:13, color:'#7a6a5a', lineHeight:1.5, marginBottom:10 }}>{v.description}</p>
        <div className="vendor-meta">
          <div className="vendor-location">📍 {v.homeZip} · travels {v.radius}mi</div>
        </div>
        {showDist && (
          outOfRange
            ? <div className="vendor-no-match">✗ {v.dist!==null?`${v.dist.toFixed(1)} mi away`:'distance unknown'} — outside travel range</div>
            : <div className="vendor-distance">✓ {v.dist!==null?`${v.dist.toFixed(1)} mi from your event`:'within range (zip unverified)'}</div>
        )}
        <div style={{display:'flex',flexDirection:'column',gap:6,marginTop:10}} onClick={e=>e.stopPropagation()}>
          {hostEvent && sendBookingRequest && (
            req ? (
              <div style={{
                padding:'8px 12px', borderRadius:8, fontSize:13, fontWeight:600, textAlign:'center',
                background: req.status==='accepted'?'#d4f4e0': req.status==='declined'?'#fdecea':'#fdf4dc',
                color: req.status==='accepted'?'#1a6b3a': req.status==='declined'?'#8b1a1a':'#7a5a10',
                border: '1px solid ' + (req.status==='accepted'?'#b8e8c8': req.status==='declined'?'#f5c6c6':'#ffd966')
              }}>
                {req.status==='pending' && `⏳ Invite Pending for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='accepted' && `✅ Accepted for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='declined' && `❌ Declined for ${req.eventName || hostEvent?.eventName || 'Event'}`}
                {req.status==='cancelled' && '↩ Request Cancelled'}
                {req.status==='withdrawn' && '↩ Withdrawn'}
              </div>
            ) : (
              <div style={{display:'flex',flexDirection:'column',gap:4}}>
                <button className="contact-btn" style={{background:'#c8a84b',color:'#1a1410',fontWeight:700,fontSize:13}} onClick={()=>{
                  if (hostEvent?.source === 'Recurring Series' && userEvents) {
                    const series = userEvents.filter(ue=>ue.event_name===hostEvent.eventName&&ue.status==='approved').sort((a,b)=>(a.date||'').localeCompare(b.date||''));
                    if (series.length > 1) { setInviteDatePicker({vendor:v, series}); return; }
                  }
                  sendBookingRequest(v, hostEvent);
                }}>
                  📋 Invite to {hostEvent?.eventName || 'My Event'}{hostEvent?.date ? ' — '+fmtDate(hostEvent.date) : ''}
                  {hostEvent?.source === 'Recurring Series' && userEvents && userEvents.filter(ue=>ue.event_name===hostEvent.eventName&&ue.status==='approved').length > 1 ? ' ▼' : ''}
                </button>
              </div>
            )
          )}
          {req && req.status==='pending' && (
            <button className="contact-btn" style={{background:'#fdecea',color:'#8b1a1a',border:'1px solid #f5c6c6',fontSize:11,fontWeight:600}} onClick={async(e)=>{e.stopPropagation();if(!window.confirm('Withdraw this invite?'))return;const delId=req.id;const{error:delErr}=await supabase.from('booking_requests').delete().eq('id',delId);if(delErr){console.error('Withdraw invite failed:',delErr);alert('Failed to withdraw invite. Please try again.');return;}setBookingRequests(prev=>prev.filter(x=>String(x.id)!==String(delId)));}}>Withdraw Invite</button>
          )}
          {openMessage && authUser && (
            <button className="contact-btn" style={{background:'#1a1410',color:'#e8c97a',fontWeight:700,fontSize:13}} onClick={()=>hostEvent ? (setEventMessageModal && setEventMessageModal({vendor:v, eventName: hostEvent.eventName + (hostEvent.date ? ' — ' + fmtDate(hostEvent.date) : '')})) : (setInquiryModal && setInquiryModal({vendor:v}))}>
              💬 Message Vendor
            </button>
          )}
          {!authUser && (
            <button className="contact-btn" style={{background:'#f5f0ea',color:'#1a1410',border:'1px solid #e0d5c5',fontWeight:600,fontSize:13}} onClick={()=>setShowAuthModal && setShowAuthModal(true)}>
              Log In to Message
            </button>
          )}
          <div style={{display:'flex',gap:6}}>
            <button className="contact-btn" style={{flex:2,background:'#f5f0ea',color:'#1a1410',border:'1px solid #e0d5c5',fontSize:12}} onClick={()=>setShowProfile(true)}>
              View Profile
            </button>
            <button className="contact-btn" style={{flex:1,background:contacted.includes(v.id)?'#1a6b3a':'#f5f0ea',color:contacted.includes(v.id)?'#fff':'#1a1410',border:'1px solid #e0d5c5',fontSize:12}} onClick={()=>setContacted(c=>c.includes(v.id)?c:[...c,v.id])}>
              {contacted.includes(v.id)?'✓ Saved':'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
    {showProfile && (
      <VendorProfileModal v={v} onClose={()=>setShowProfile(false)}
        sendBookingRequest={sendBookingRequest} hostEvent={hostEvent}
        bookingRequests={bookingRequests} openMessage={openMessage} setTab={setTab} matchPct={matchPct} />
    )}
    {inviteDatePicker && (
      <InviteDatePickerModal
        vendor={inviteDatePicker.vendor}
        series={inviteDatePicker.series}
        hostEvent={hostEvent}
        sendBookingRequest={sendBookingRequest}
        onClose={()=>setInviteDatePicker(null)}
      />
    )}
    </>
  );
}

export default VendorCard;
